import React, { useState, useEffect, Fragment, useRef } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
  Box, Card, Grid, TextField, makeStyles, Container, Button, CardContent, Divider, InputLabel, CardHeader,
  MenuItem, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Typography, TablePagination
} from '@material-ui/core';
import Page from 'src/components/Page';
import services from '../Services';
import { trackPromise } from 'react-promise-tracker';
import { Formik } from 'formik';
import * as Yup from "yup";
import authService from '../../../../utils/permissionAuth';
import tokenService from '../../../../utils/tokenDecoder';
import { useNavigate } from 'react-router-dom';
import { useAlert } from "react-alert";
import xlsx from 'json-as-xlsx';
import ReactToPrint from "react-to-print";
import CreatePDF from './CreatePDF';
import { LoadingComponent } from './../../../../utils/newLoader';
import moment from 'moment';
import _, { map, set } from 'lodash';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  avatar: {
    marginRight: theme.spacing(2)
  },
  colorCancel: {
    backgroundColor: "red",
  },
  colorRecord: {
    backgroundColor: "green",
  },
}));

const getPreviousMonth = () => {
  const today = new Date();
  const year = today.getFullYear();
  const month = today.getMonth();
  let previousMonth = month === 0 ? 11 : month - 1;
  let previousYear = month === 0 ? year - 1 : year;
  const formattedMonth = String(previousMonth + 1).padStart(2, '0');

  return `${previousYear}-${formattedMonth}`;
};

const getPageMargins = () => {
  return `@media print {
            @page {
            background-color: white !important;
        }
        body {
            background-color: white !important;
        }
    }`;
};

const screenCode = 'NOTSUPPLYDEBTLISTREPORT2';

export default function NotSupplyDebtListReport(props) {
  const [title, setTitle] = useState("Not Supply Debt List Report 2");
  const classes = useStyles();
  const [GroupList, setGroupList] = useState([]);
  const [FactoryList, setFactoryList] = useState([]);
  const [routeList, setRouteList] = useState();
  const [limit, setLimit] = useState(5);
  const [page, setPage] = useState(0)
  const [totalAmount, setTotalAmount] = useState(0);
  const [totalLoanBalance, setTotalLoanBalance] = useState(0);
  const [totalBalance, setTotalBalance] = useState(0);
  const [notSupplyDebtDetail, setNotSupplyDebtDetail] = useState({
    groupID: 0,
    factoryID: 0,
    routeID: 0,
    date: getPreviousMonth(),
  });
  const [notSupplyDebtList, setNotSupplyDebtList] = useState([]);
  const [permissionList, setPermissions] = useState({
    isGroupFilterEnabled: false,
    isFactoryFilterEnabled: false,
  });
  const [selectedSearchValues, setSelectedSearchValues] = useState({
    groupName: "0",
    factoryName: "0",
    routeName: "0",
    date: ''
  });
  const [csvHeaders, SetCsvHeaders] = useState([]);
  const navigate = useNavigate();
  const alert = useAlert();
  const componentRef = useRef();

  const handleLimitChange = (event) => {
    setLimit(event.target.value);
  };
  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  useEffect(() => {
    trackPromise(
      getPermission());
    trackPromise(
      getGroupsForDropdown());
  }, []);

  useEffect(() => {
    trackPromise(
      getFactoriesForDropdown());
  }, [notSupplyDebtDetail.groupID]);

  useEffect(() => {
    trackPromise(
      getRoutesByFactoryID());
  }, [notSupplyDebtDetail.factoryID]);

  async function getPermission() {
    var permissions = await authService.getPermissionsByScreen(screenCode);
    var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWNOTSUPPLYDEBTLISTREPORT2');

    if (isAuthorized === undefined) {
      navigate('/404');
    }
    var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
    var isFactoryFilterEnabled = permissions.find(p => p.permissionCode == 'FACTORYDROPDOWN');

    setPermissions({
      ...permissionList,
      isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
      isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined,
    });

    setNotSupplyDebtDetail({
      ...notSupplyDebtDetail,
      groupID: parseInt(tokenService.getGroupIDFromToken()),
      factoryID: parseInt(tokenService.getFactoryIDFromToken())
    })
  }

  async function getGroupsForDropdown() {
    const groups = await services.getAllGroups();
    setGroupList(groups);
  }

  async function getFactoriesForDropdown() {
    const factories = await services.getFactoryByGroupID(notSupplyDebtDetail.groupID);
    setFactoryList(factories);
  }

  async function getRoutesByFactoryID() {
    const routes = await services.getRoutesForDropDown(notSupplyDebtDetail.factoryID);
    setRouteList(routes);
  }

  async function GetNotSupplyDebtList() {
    let model = {
      groupID: parseInt(notSupplyDebtDetail.groupID),
      factoryID: parseInt(notSupplyDebtDetail.factoryID),
      routeID: parseInt(notSupplyDebtDetail.routeID),
      date: notSupplyDebtDetail.date,
    }
    const response = await services.GetNotSupplyDebtList2(model);
    getSelectedDropdownValuesForReport(model);
    if (response.statusCode == "Success" && response.data != null) {
      setNotSupplyDebtList(response.data);
      createDataForExcel(response.data);
      calculateTotalBalanceSum(response.data);
      calculateTotalLoanBalanceSum(response.data);
      calculateTotalAmountSum(response.data);

      if (response.data.length == 0) {
        alert.error("No records to display");
      }
    }
    else {
      alert.error(response.message);

    }
  }

  async function createDataForExcel(array) {
    var res = [];

    if (array != null) {
      array.forEach(group => {
        group.records.forEach(rec => {
          res.push({
            'Route Name': group.routeName,
            'Registration Number': rec.registrationNumber,
            'Customer Name': rec.name,
            'Last 3 Months Crop Avg (Kg)': parseFloat(
              calculateAverage(rec.month1, rec.month2, rec.month3).toFixed(2)
            ),
            'Todate Crop (Kg)': parseFloat(rec.todateCrop.toFixed(2)),
            'Debt Amount (Rs)': parseFloat(rec.amount.toFixed(2)),
            'Loan Balance (Rs)': parseFloat(rec.loanBalance.toFixed(2)),
            'Last Supply Month': rec.lastSupplyMonth,
            'Amount': parseFloat(rec.balance.toFixed(2))
          });
        });

        res.push({
          'Route Name': '',
          'Registration Number': '',
          'Customer Name': '',
          'Last 3 Months Crop Avg (Kg)': '',
          'Todate Crop (Kg)': '',
          'Debt Amount (Rs)': '',
          'Loan Balance (Rs)': '',
          'Last Supply Month': '',
          'Amount': '',
        });

        res.push({
          'Route Name': `Route Total: (${group.records.length})`,
          'Registration Number': '',
          'Customer Name': '',
          'Last 3 Months Crop Avg (Kg)': '',
          'Todate Crop (Kg)': '',
          'Debt Amount (Rs)': parseFloat(group.totalAmount),
          'Loan Balance (Rs)': parseFloat(group.totalLoanBalance),
          'Last Supply Month': '',
          'Amount': parseFloat(group.totalBalance),
        });

        res.push({
          'Route Name': '',
          'Registration Number': '',
          'Customer Name': '',
          'Last 3 Months Crop Avg (Kg)': '',
          'Todate Crop (Kg)': '',
          'Debt Amount (Rs)': '',
          'Loan Balance (Rs)': '',
          'Last Supply Month': '',
          'Amount': '',
        });

      });

      {
        if (notSupplyDebtDetail.routeID == 0) {
          res.push({
            'Route Name': 'Grand Total:',
            'Registration Number': '',
            'Customer Name': '',
            'Last 3 Months Crop Avg (Kg)': '',
            'Todate Crop (Kg)': '',
            'Debt Amount (Rs)': parseFloat(totalAmount),
            'Loan Balance (Rs)': parseFloat(totalLoanBalance),
            'Last Supply Month': '',
            'Amount': parseFloat(totalBalance),
          });
          res.push([]);
        }
      }

      var vr = {
        'Route Name': 'Group- ' + selectedSearchValues.groupName,
        'Registration Number': 'Factory - ' + selectedSearchValues.factoryName,
      };
      res.push(vr);

      var vr2 = {
        'Route Name': 'Route - ' + (selectedSearchValues.routeName === undefined ? 'All Routes' : selectedSearchValues.routeName),
        'Registration Number': 'Month & Year - ' + moment(selectedSearchValues.date).format('YYYY-MM'),
      };
      res.push(vr2);

    }
    return res;
  }
  async function createFile() {

    var file = await createDataForExcel(notSupplyDebtList);
    var settings = {
      sheetName: 'Not Supply Debt List Report 2',
      fileName: 'Not Supply Debt List Report 2 - ' + selectedSearchValues.groupName + ' - ' + selectedSearchValues.factoryName + ' - ' + (selectedSearchValues.routeName === undefined ? 'All Routes' : selectedSearchValues.routeName) + ' - ' + moment(selectedSearchValues.date).format('YYYY-MM'),
      writeOptions: {}
    }

    let keys = Object.keys(file[0])
    let tempcsvHeaders = csvHeaders;
    keys.map((sitem, i) => {
      tempcsvHeaders.push({ label: sitem, value: sitem })
    })

    let dataA = [
      {
        sheet: 'Not Supply Debt List Report 2',
        columns: tempcsvHeaders,
        content: file
      }
    ]

    xlsx(dataA, settings);
  }

  function calculateTotalBalanceSum(data) {
    const totalBalanceSum = data.reduce((acc, item) => acc + (parseFloat(item.totalBalance) || 0), 0);
    setTotalBalance(totalBalanceSum);
  }

  function calculateTotalLoanBalanceSum(data) {
    const totalLoanBalanceSum = data.reduce((acc, item) => acc + (parseFloat(item.totalLoanBalance) || 0), 0);
    setTotalLoanBalance(totalLoanBalanceSum);
  }

  function calculateTotalAmountSum(data) {
    const totalAmountSum = data.reduce((acc, item) => acc + (parseFloat(item.totalAmount) || 0), 0);
    setTotalAmount(totalAmountSum);
  }

  function generateDropDownMenu(data) {
    let items = []
    if (data != null) {
      for (const [key, value] of Object.entries(data)) {
        items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
      }
    }
    return items;
  }

  function handleChange(e) {
    const target = e.target;
    const value = target.value
    if (target.name === 'groupID') {
      setNotSupplyDebtDetail({
        ...notSupplyDebtDetail,
        [e.target.name]: value,
        factoryID: 0,
        routeID: 0
      });
    } else if (target.name === 'factoryID') {
      setNotSupplyDebtDetail({
        ...notSupplyDebtDetail,
        [e.target.name]: value,
        routeID: 0
      });
    }else {
      setNotSupplyDebtDetail({
        ...notSupplyDebtDetail,
        [e.target.name]: value
      });
    }
    setNotSupplyDebtList([]);
  }

  function getSelectedDropdownValuesForReport(searchForm) {

    setSelectedSearchValues({
      ...selectedSearchValues,
      groupName: GroupList[searchForm.groupID],
      factoryName: FactoryList[searchForm.factoryID],
      routeName: routeList[searchForm.routeID],
      date: searchForm.date
    })
  }

  function calculateAverage(month1, month2, month3) {
    const count = [month1, month2, month3].filter(val => val !== 0 && val !== null && val !== undefined).length;
    if (count === 0) return 0;
    const sum = (month1 || 0) + (month2 || 0) + (month3 || 0);
    return sum / count;
  }

  function cardTitle(titleName) {
    return (
      <Grid container spacing={1}>
        <Grid item md={10} xs={12}>
          {titleName}
        </Grid>
      </Grid>
    )
  }

  return (
    <Fragment>
      <LoadingComponent />
      <Page className={classes.root} title={title}>
        <Container maxWidth={false}>
          <Formik
            initialValues={{
              groupID: notSupplyDebtDetail.groupID,
              factoryID: notSupplyDebtDetail.factoryID
            }}
            validationSchema={
              Yup.object().shape({
                groupID: Yup.number().required('Group is required').min("1", 'Group is required'),
                factoryID: Yup.number().required('Factory is required').min("1", 'Factory is required'),
              })
            }
            onSubmit={() => trackPromise(GetNotSupplyDebtList())}
            enableReinitialize
          >
            {({
              errors,
              handleBlur,
              handleSubmit,
              touched
            }) => (
              <form onSubmit={handleSubmit}>
                <Box mt={0}>
                  <Card>
                    <CardHeader title={cardTitle(title)} />
                    <PerfectScrollbar>
                      <Divider />
                      <CardContent>
                        <Grid container spacing={3}>
                          <Grid item md={3} xs={8}>
                            <InputLabel shrink id="groupID">
                              Group *
                            </InputLabel>
                            <TextField select
                              error={Boolean(touched.groupID && errors.groupID)}
                              fullWidth
                              helperText={touched.groupID && errors.groupID}
                              name="groupID"
                              onBlur={handleBlur}
                              onChange={(e) => handleChange(e)}
                              value={notSupplyDebtDetail.groupID}
                              variant="outlined"
                              id="groupID"
                              disabled={!permissionList.isGroupFilterEnabled}
                              size='small'
                            >
                              <MenuItem value="0">--Select Group--</MenuItem>
                              {generateDropDownMenu(GroupList)}
                            </TextField>
                          </Grid>
                          <Grid item md={3} xs={8}>
                            <InputLabel shrink id="factoryID">
                              Factory *
                            </InputLabel>
                            <TextField select
                              error={Boolean(touched.factoryID && errors.factoryID)}
                              fullWidth
                              helperText={touched.factoryID && errors.factoryID}
                              name="factoryID"
                              onBlur={handleBlur}
                              onChange={(e) => handleChange(e)}
                              value={notSupplyDebtDetail.factoryID}
                              variant="outlined"
                              id="factoryID"
                              disabled={!permissionList.isFactoryFilterEnabled}
                              size='small'
                            >
                              <MenuItem value="0">--Select Factory--</MenuItem>
                              {generateDropDownMenu(FactoryList)}
                            </TextField>
                          </Grid>
                          <Grid item md={3} xs={12}>
                            <InputLabel shrink id="routeID">
                              Route
                            </InputLabel>
                            <TextField select
                              fullWidth
                              name="routeID"
                              onChange={(e) => handleChange(e)}
                              value={notSupplyDebtDetail.routeID}
                              variant="outlined"
                              id="routeID"
                              size='small'
                            >
                              <MenuItem value="0">--Select Route--</MenuItem>
                              {generateDropDownMenu(routeList)}
                            </TextField>
                          </Grid>
                          <Grid item md={3} xs={12}>
                            <InputLabel shrink id="date">
                              Month
                            </InputLabel>
                            <TextField
                              error={Boolean(touched.date && errors.date)}
                              fullWidth
                              helperText={touched.date && errors.date}
                              size='small'
                              name="date"
                              type="month"
                              onChange={(e) => handleChange(e)}
                              value={notSupplyDebtDetail.date}
                              variant="outlined"
                              id="date"
                            />
                          </Grid>
                        </Grid>
                        <Box display="flex" flexDirection="row-reverse" p={2} >
                          <Button
                            color="primary"
                            type="submit"
                            variant="contained"
                            size='small'
                          >
                            Search
                          </Button>
                        </Box>
                      </CardContent>
                      {notSupplyDebtList.length > 0 ?
                        <Box display="flex" justifyContent="flex-end" p={2}>
                          <TableContainer component={Paper}>
                            <Table>
                              <TableHead>
                                <TableRow>
                                  <TableCell align="center" style={{ border: "1px solid black" }}>Registration Number</TableCell>
                                  <TableCell align="center" style={{ border: "1px solid black" }}>Customer Name</TableCell>
                                  <TableCell align="center" style={{ border: "1px solid black" }}>Last 3 Months Crop Avg (Kg)</TableCell>
                                  <TableCell align="center" style={{ border: "1px solid black" }}>To date Crop (Kg)</TableCell>
                                  <TableCell align="center" style={{ border: "1px solid black" }}>Debt Amount (Rs)</TableCell>
                                  <TableCell align="center" style={{ border: "1px solid black" }}>Loan Balance (Rs)</TableCell>
                                  <TableCell align="center" style={{ border: "1px solid black" }}>Last Supply Month</TableCell>
                                  <TableCell align="center" style={{ border: "1px solid black" }}>Balance (Rs)</TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {notSupplyDebtList.slice(page * limit, page * limit + limit).map((group, index) => (
                                  <React.Fragment key={index}>
                                    <TableRow>
                                      <TableCell colSpan={8} align="center" border="1px solid black" style={{ backgroundColor: "#B0C4DE", fontWeight: "bold", border: "1px solid black" }}>
                                        {group.routeName}
                                      </TableCell>
                                    </TableRow>
                                    {group.records.map((rec, idx) => (
                                      <TableRow key={`${index}-${idx}`}>
                                        <TableCell style={{ border: "1px solid black" }}>{rec.registrationNumber}</TableCell>
                                        <TableCell style={{ border: "1px solid black" }}>{rec.name}</TableCell>
                                       <TableCell align="right" component="th" scope="row" style={{ border: "1px solid black" }}>
                                        {(
                                          (rec.month1 + rec.month2 + rec.month3) /
                                          (
                                            rec.month1 === 0 && rec.month2 === 0 && rec.month3 === 0
                                              ? 1
                                              : [rec.month1, rec.month2, rec.month3].filter(val => val !== 0 && val !== null && val !== undefined).length
                                          )
                                        ).toFixed(2)}
                                      </TableCell>
                                        <TableCell align={'right'} component="th" scope="row" style={{ border: "1px solid black" }}>{rec.todateCrop.toFixed(2)}</TableCell>
                                        <TableCell align={'right'} component="th" scope="row" style={{ border: "1px solid black" }}>{rec.amount.toFixed(2)}</TableCell>
                                        <TableCell align={'right'} component="th" scope="row" style={{ border: "1px solid black" }}>{rec.loanBalance.toFixed(2)}</TableCell>
                                        <TableCell style={{ border: "1px solid black" }}>{rec.lastSupplyMonth}</TableCell>
                                        <TableCell align="right" style={{ border: "1px solid black" }}>{rec.balance.toFixed(2)}</TableCell>
                                      </TableRow>
                                    ))}
                                    <TableRow>
                                      <TableCell colSpan={4} align="left" style={{ border: "1px solid black" }}><b>Route Total: ({group.records.length})</b></TableCell>
                                      <TableCell align="right" style={{ border: "1px solid black" }}><b>{group.totalAmount.toLocaleString(undefined, { minimumFractionDigits: 2 })}</b></TableCell>
                                      <TableCell align="right" style={{ border: "1px solid black" }}><b>{group.totalLoanBalance.toLocaleString(undefined, { minimumFractionDigits: 2 })}</b></TableCell>
                                      <TableCell align="right" style={{ border: "1px solid black" }}><b></b></TableCell>
                                      <TableCell align="right" style={{ border: "1px solid black" }}><b>{group.totalBalance.toLocaleString(undefined, { minimumFractionDigits: 2 })}</b></TableCell>
                                    </TableRow>
                                  </React.Fragment>
                                ))
                                }
                                {notSupplyDebtDetail.routeID == 0 ?
                                  <TableRow>
                                    <TableCell colSpan={4} align="left" style={{ border: "1px solid black" }}><b>Grand Total:</b></TableCell>
                                    <TableCell align="right" style={{ border: "1px solid black" }}><b>{totalAmount.toLocaleString(undefined, { minimumFractionDigits: 2 })}</b></TableCell>
                                    <TableCell align="right" style={{ border: "1px solid black" }}><b>{totalLoanBalance.toLocaleString(undefined, { minimumFractionDigits: 2 })}</b></TableCell>
                                    <TableCell align="right" style={{ border: "1px solid black" }}><b></b></TableCell>
                                    <TableCell align="right" style={{ border: "1px solid black" }}><b>{totalBalance.toLocaleString(undefined, { minimumFractionDigits: 2 })}</b></TableCell>
                                  </TableRow>
                                  : null}
                              </TableBody>
                            </Table>
                            <TablePagination
                              component="div"
                              count={notSupplyDebtList.length}
                              page={page}
                              onChangePage={handlePageChange}
                              rowsPerPage={limit}
                              onChangeRowsPerPage={handleLimitChange}
                              rowsPerPageOptions={[5, 10, 25, 50]}
                            />
                          </TableContainer>
                        </Box>
                        : null}
                      {notSupplyDebtList.length > 0 ?
                        <Box display="flex" justifyContent="flex-end" p={2}>
                          <Button
                            color="primary"
                            id="btnRecord"
                            type="submit"
                            variant="contained"
                            style={{ marginRight: '1rem' }}
                            className={classes.colorRecord}
                            onClick={() => createFile()}
                            size='small'
                          >
                            EXCEL
                          </Button>
                          <ReactToPrint
                            documentTitle={"Not Supply Debt List Report 2" + ' - ' + selectedSearchValues.groupName + ' - ' + selectedSearchValues.factoryName + ' - ' + (selectedSearchValues.routeName === undefined ? 'All Routes' : selectedSearchValues.routeName) + ' - ' + moment(selectedSearchValues.date).format('YYYY-MM')}
                            trigger={() => <Button
                              color="primary"
                              id="btnRecord"
                              type="submit"
                              variant="contained"
                              style={{ marginRight: '1rem' }}
                              className={classes.colorCancel}
                              size='small'
                            >
                              PDF
                            </Button>}
                            content={() => componentRef.current}
                            pageStyle={getPageMargins()}
                          />
                          <div hidden={true}>
                            <CreatePDF
                              ref={componentRef}
                              notSupplyDebtList={notSupplyDebtList}
                              searchData={selectedSearchValues}
                              totalAmount={totalAmount}
                              totalLoanBalance={totalLoanBalance}
                              totalBalance={totalBalance}
                            />
                          </div>
                        </Box> : null}
                    </PerfectScrollbar>
                  </Card>
                </Box>
              </form>
            )}
          </Formik>
        </Container>
      </Page>
    </Fragment>
  );
}
